module.exports = __webpack_public_path__ + "static/bgHeroMantenimiento-36b19a983103354caebe80f863f4e838.jpg";